import { Link, useForm } from "@inertiajs/react";
import type { FormEvent } from "react";

import backgroundBlue from "@/assets/background_blue.svg";
import AuthCard from "@/components/AuthCard";
import Button from "@/components/Button";
import PasswordField from "@/components/PasswordField";
import TextField from "@/components/TextField";
import { passwords, registrations, sessions } from "@/routes";

type Props = {
  return_to?: string | null;
};

export default function SessionsNew({ return_to }: Props) {
  const form = useForm({ rut: "", password: "", remember: false });

  function submit(e: FormEvent) {
    e.preventDefault();
    form.transform((data) => ({ session: data, return_to }));
    form.post(sessions.create().url);
  }

  return (
    <AuthCard
      title="Iniciar sesión"
      subtitle="Utiliza tu mismo RUT y clave que ya tienes registrado para iniciar sesión."
      background={backgroundBlue}
    >
      <form onSubmit={submit} className="mx-auto flex max-w-xl flex-col gap-4">
        <TextField
          name="rut"
          placeholder="Rut / Pasaporte"
          autoComplete="username"
          value={form.data.rut}
          onChange={(e) => form.setData("rut", e.target.value)}
          adornment={<span className="text-xl text-ink/60">∗</span>}
          required
        />

        <PasswordField
          name="password"
          placeholder="Contraseña"
          autoComplete="current-password"
          value={form.data.password}
          onChange={(e) => form.setData("password", e.target.value)}
          required
        />

        <div className="flex flex-col gap-2 px-1">
          <Link
            href={passwords.new().url}
            className="self-start font-sans text-sm text-ink underline underline-offset-2 hover:text-steel"
          >
            Olvidé mi contraseña
          </Link>
          <label className="flex w-fit cursor-pointer items-center gap-2 self-start font-sans text-sm text-ink">
            <input
              type="checkbox"
              checked={form.data.remember}
              onChange={(e) => form.setData("remember", e.target.checked)}
              className="h-4 w-4 rounded-full border-ink/50 text-steel focus:ring-steel/40"
            />
            <span className="underline underline-offset-2">
              Recordar credenciales
            </span>
          </label>
        </div>

        <Button
          type="submit"
          disabled={form.processing}
          className="mt-2 w-full"
        >
          Iniciar sesión
        </Button>

        <Link
          href={registrations.new().url}
          className="mt-1 self-center font-sans text-sm font-medium text-ink uppercase underline underline-offset-2 hover:text-steel"
        >
          Aún no estoy registrado
        </Link>
      </form>
    </AuthCard>
  );
}
